import type { RequestRow } from '../types';
import { HudFrame } from './HudFrame';

export function HistoryPanel({
  rows,
  total,
  selectedId,
  onOpen,
  onRerun,
}: {
  rows: RequestRow[];
  total: number;
  selectedId: string | null;
  onOpen: (id: string) => void;
  onRerun: (phone: string) => void;
}) {
  return (
    <HudFrame title="REQUEST LOG" code="LOG-01" status={rows.length ? 'live' : 'idle'} meta={`${total} tracked`}>
      {!rows.length ? (
        <p className="empty">All lookups are recorded here. Click a row to reopen stored details.</p>
      ) : (
        <div className="hist">
          <table className="hist__table">
            <thead>
              <tr>
                <th>Time</th>
                <th>Number</th>
                <th>Src</th>
                <th>Status</th>
                <th>ms</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => {
                const phone = r.phone_e164 || r.phone_raw;
                const active = selectedId === r.id;
                return (
                  <tr key={r.id} className={active ? 'hist__row--active' : undefined}>
                    <td className="hist__time">
                      <button
                        type="button"
                        className="hist__open"
                        onClick={() => onOpen(r.id)}
                        title="Open stored result"
                      >
                        {new Date(r.created_at).toLocaleString(undefined, {
                          month: 'short',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit',
                        })}
                      </button>
                    </td>
                    <td>
                      <button
                        type="button"
                        className="hist__phone"
                        onClick={() => onOpen(r.id)}
                        title="Open stored result"
                      >
                        {phone}
                      </button>
                    </td>
                    <td>{r.source}</td>
                    <td>
                      <span
                        className={`chip chip--xs chip--${r.status === 'ok' ? 'ok' : r.status === 'error' ? 'bad' : 'warn'}`}
                      >
                        {r.status}
                      </span>
                    </td>
                    <td className="hist__ms">{r.duration_ms ?? '—'}</td>
                    <td>
                      <button
                        type="button"
                        className="btn btn--tiny hist__rerun"
                        onClick={(e) => {
                          e.stopPropagation();
                          onRerun(phone);
                        }}
                        title="Run a fresh lookup (new request)"
                      >
                        RE-RUN
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </HudFrame>
  );
}
